import { createFileRoute } from '@tanstack/react-router'

import { VerifyTwoFactorPage } from '@/pages/(auth)/VerifyTwoFactorPage'

export const Route = createFileRoute('/login_/verify-2fa')({
  component: VerifyTwoFactorPage,
})
